export enum Networks {
  Sepolia = 'Ethereum (Sepolia)',
  Goerli = 'Ethereum (Goerli)',
  Polygon = 'Polygon (Mumbai)',
  Optimism = 'Optimism (Goerli)',
}
